'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLandingPageSearchQuery = exports.getDeletedItemTitleIfNeeded = exports.searchCategory = exports.getLandingPageMetaData = exports.getAuctionResultsLandingPageUrl = exports.getCategoryLandingPageUrl = exports.getPageLabel = exports.LOAD_CATEGORY_RESULTS_SUCCESS = exports.LOAD_CATEGORY_RESULTS_REQUEST = exports.LOAD_CATEGORY_RESULTS_FAIL = undefined;

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('../modules/config');

var _item = require('../modules/item');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATEGORY_RESULTS_FAIL = exports.LOAD_CATEGORY_RESULTS_FAIL = 'LOAD_CATEGORY_RESULTS_FAIL';
var LOAD_CATEGORY_RESULTS_REQUEST = exports.LOAD_CATEGORY_RESULTS_REQUEST = 'LOAD_CATEGORY_RESULTS_REQUEST';
var LOAD_CATEGORY_RESULTS_SUCCESS = exports.LOAD_CATEGORY_RESULTS_SUCCESS = 'LOAD_CATEGORY_RESULTS_SUCCESS';

// reducer
var DEFAULT_STATE = {
    // error: false,
    // isLoading: true,
    metaData: {
        pageLabel: '',
        pageMetaDescription: '',
        pageMetaKeywords: '',
        pageTitle: ''
    }
    // submitted: false,
    // success: false,
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATEGORY_RESULTS_SUCCESS:
            var metaData = state.metaData;
            if (action.payload.landingPageMetaData) {
                metaData = {
                    pageLabel: action.payload.landingPageMetaData.label,
                    pageMetaDescription: action.payload.landingPageMetaData.metaDescription,
                    pageMetaKeywords: action.payload.landingPageMetaData.metaKeywords,
                    pageTitle: action.payload.landingPageMetaData.pageTitle
                };
            }
            return (0, _extends3.default)({}, state, {
                // isLoading: false,
                metaData: metaData
                // submitted: false,
                // success: true,
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.landingPage;
};
// const idSelector = (state, id) => id;

// const errorSelector = createSelector(
//     stateSelector,
//     state => state.error,
// );

// const isLoadingSelector = createSelector(
//     stateSelector,
//     state => state.isLoading,
// );

var metaDataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.metaData;
});

// const submittedSelector = createSelector(
//     stateSelector,
//     state => state.submitted,
// );

// const successSelector = createSelector(
//     stateSelector,
//     state => state.success,
// );

var getPageMetaDescription = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageMetaDescription;
});

var getPageMetaKeywords = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageMetaKeywords;
});

var getPageTitle = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageTitle;
});

var getPageLabel = exports.getPageLabel = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageLabel;
});

var getCategoryLandingPageUrl = exports.getCategoryLandingPageUrl = function getCategoryLandingPageUrl(params) {
    return getLandingPageUrl(params, 'c');
};

var getAuctionResultsLandingPageUrl = exports.getAuctionResultsLandingPageUrl = function getAuctionResultsLandingPageUrl(params) {
    return getLandingPageUrl(params, 'price-guide');
};

var getLandingPageUrl = function getLandingPageUrl(params, route) {
    if (!params.categoryId || (0, _isNan2.default)(Number(params.categoryId))) {
        return '/' + route + '/';
    } else if (params.categoryId2 && params.categoryName2) {
        return '/' + route + '/' + params.categoryName + '/' + params.categoryName2 + '/' + params.categoryId + '/' + params.categoryId2 + '/';
    }
    return '/' + route + '/' + params.categoryName + '/' + params.categoryId + '/';
};

var getLandingPageMetaData = exports.getLandingPageMetaData = function getLandingPageMetaData(state, params) {
    var landingPageMetaData = {
        pageMetaDescription: getPageMetaDescription(state),
        pageMetaKeywords: getPageMetaKeywords(state),
        pageTitle: getPageTitle(state),
        pageUrl: getCategoryLandingPageUrl(params)
    };

    return (0, _cloneDeep2.default)(landingPageMetaData);
};

/* ACTION CREATORS */
var categoryResultsFail = function categoryResultsFail(searchQuery, error) {
    return {
        error: true,
        meta: { searchQuery: searchQuery },
        payload: error,
        type: LOAD_CATEGORY_RESULTS_FAIL
    };
};

var categoryResultsRequest = function categoryResultsRequest(searchQuery) {
    return {
        payload: searchQuery,
        type: LOAD_CATEGORY_RESULTS_REQUEST
    };
};

var categoryResultsSuccess = function categoryResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_CATEGORY_RESULTS_SUCCESS
    };
};

var searchCategory = exports.searchCategory = function searchCategory(searchQuery, ids) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(categoryResultsRequest(searchQuery));
        return _api.Search.fetchCategoryResults({ deployment: deployment, ids: ids, searchQuery: searchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(categoryResultsFail(searchQuery, results));
            } else {
                dispatch(categoryResultsSuccess(results));
            }
        }).catch(function (error) {
            dispatch(categoryResultsFail(searchQuery, error));
        });
    };
};

var getDeletedItemTitleIfNeeded = exports.getDeletedItemTitleIfNeeded = function getDeletedItemTitleIfNeeded(state, query) {
    var item = void 0;
    var returnTitle = '';
    if (query.deleted && !isNaN(query.deleted)) {
        item = (0, _item.getItem)(state, query.deleted) || {
            isDeleted: true,
            title: 'The item you were seeking'
        };
    }
    if (item && item.isDeleted && item.title) {
        returnTitle = item.title;
    }
    return returnTitle;
};

var getCategoryLandingPageSearchQuery = exports.getCategoryLandingPageSearchQuery = function getCategoryLandingPageSearchQuery(pathname, savedSearchQuery) {
    var result = (0, _cloneDeep2.default)(savedSearchQuery);

    if (pathname.includes('/c/') && !result.campaignId) {
        var pathCategoryIds = pathname.match(/\d+/g);
        pathCategoryIds = pathCategoryIds ? pathCategoryIds.join() : '';
        var category_id = savedSearchQuery.category_id;


        if (!category_id) {
            result.category_id = pathCategoryIds;
        } else {
            result.category_id = pathCategoryIds + ',' + savedSearchQuery.category_id;
        }
    }

    return result;
};

//TODO: rename all the categories to landing where appropriate


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/landingPage.js
// module id = 1Hq4
// module chunks = 46